import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { authenticationGuard } from "@/auth/authGuard";

Vue.use(VueRouter);

// Allow bypassing auth for e2e tests via environment variable
const authGuard =
  process.env.VUE_APP_DISABLE_AUTH === "true" ? undefined : authenticationGuard;

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "StartPage",
    component: () => import("../views/StartPage.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/mcp-info",
    name: "McpInfo",
    component: () => import("../views/McpInfo.vue"),
  },
  {
    path: "/tree/:hash",
    name: "TreeWithHash",
    props: true,
    component: () => import("../views/Home.vue"),
    beforeEnter: authGuard,
  },
  {
    path: "/tree/",
    name: "Tree",
    component: () => import("../views/Home.vue"),
    beforeEnter: authGuard,
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

export default router;
